import * as React from 'react';
import ScreeningToolResponse from './components/ScreeningToolResponse';
import { ScreeningToolType } from './types/ScreeningTool';


const ScreeningToolResponseApp = (props) => {


  return (
    <ScreeningToolResponse screeningTools={props.screeningTools as ScreeningToolType[]}/>
  )
}
export default ScreeningToolResponseApp;
// This is a placeholder component for the Screening Tool Response.
